// extracted by mini-css-extract-plugin
module.exports = {"card-media":"ImageCardOpenArticle_card-media__1AGil","card-action-area":"ImageCardOpenArticle_card-action-area__1wLdN"};